import { HttpStatusCode } from 'axios';

import { isBaseError } from '@/api/v4/base-fetch';

export const isIdNotRecognizedError = (error: unknown): boolean => {
  return (
    isBaseError(error) &&
    (error.response.status === HttpStatusCode.NotFound ||
      error.response.status === HttpStatusCode.BadRequest)
  );
};
